module.exports = __webpack_public_path__ + "img/dressed-woman-1.5fd7d618.jpg";